import { restaurantHero } from '@/mocks/smart-restaurant';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      {/* 背景：抽象暗调 + 暖金光晕 + 生态绿光带 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20luxurious%20background%20with%20deep%20charcoal%20black%20tones%20and%20warm%20golden%20amber%20bokeh%20lights%2C%20subtle%20emerald%20green%20light%20ribbons%20flowing%20like%20data%20streams%2C%20elegant%20blurred%20ambient%20glow%2C%20cinematic%20soft%20lighting%2C%20large%20negative%20space%20on%20the%20left%20side%20for%20text%2C%20artistic%20and%20minimal%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=restaurant-hero-bg-03&orientation=landscape&nocache=true"
          alt="味聚智慧餐饮"
          title="味聚智慧餐饮解决方案"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/97 via-foreground-950/90 to-foreground-950/55"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-transparent to-foreground-950/80"></div>
      </div>

      {/* 装饰光晕（暖金 / 生态绿，克制） */}
      <div className="absolute -top-24 -right-16 w-72 h-72 md:w-[30rem] md:h-[30rem] rounded-full bg-secondary-500/12 blur-3xl animate-float-slow pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 md:w-[28rem] md:h-[28rem] rounded-full bg-accent-500/12 blur-3xl animate-float-slow pointer-events-none" style={{ animationDelay: '2s' }}></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-32 pb-20 md:pt-40 md:pb-28 flex items-center">
        <div className="max-w-7xl mx-auto w-full">
          {/* 文案 */}
          <div className="w-full max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 backdrop-blur">
              <span className="w-2 h-2 rounded-full bg-secondary-400 animate-pulse"></span>
              <span className="text-xs md:text-sm text-background-100 tracking-wide whitespace-nowrap">
                {restaurantHero.eyebrow}
              </span>
            </div>

            <h1 className="mt-6 font-heading font-bold text-background-50 leading-[1.15] text-4xl md:text-6xl">
              <span className="block">{restaurantHero.titleLine1}</span>
              <span className="block mt-1">
                {restaurantHero.titleLine2}
                <span className="relative inline-block text-secondary-300">
                  {restaurantHero.titleAccent}
                  <span className="absolute left-0 -bottom-1 w-full h-[3px] rounded-full bg-secondary-400/70"></span>
                </span>
              </span>
            </h1>

            <p className="mt-7 text-sm md:text-lg text-foreground-200 leading-relaxed max-w-xl">
              {restaurantHero.subtitle}
            </p>

            <div className="mt-4 inline-flex items-center gap-2 text-xs md:text-sm text-foreground-300">
              <i className="ri-arrow-right-up-line text-accent-400"></i>
              {restaurantHero.note}
            </div>

            {/* 数据指标 */}
            <div className="mt-9 grid grid-cols-3 gap-4 md:gap-6 max-w-xl">
              {restaurantHero.stats.map((stat) => (
                <div key={stat.label} className="border-l-2 border-secondary-500/40 pl-4">
                  <div className="flex items-baseline gap-1">
                    <span className="font-heading font-bold text-2xl md:text-4xl text-background-50 leading-none">
                      {stat.value}
                    </span>
                    <span className="text-sm md:text-base text-secondary-300 font-medium">{stat.unit}</span>
                  </div>
                  <div className="mt-2 text-[11px] md:text-xs text-foreground-400 leading-relaxed">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              {restaurantHero.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full text-xs text-background-100 bg-background-50/10 border border-background-50/15 whitespace-nowrap backdrop-blur"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 底部收边，衔接下一区块 */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-secondary-500/40 pointer-events-none"></div>
    </section>
  );
}